// extracted by mini-css-extract-plugin
var _1 = "ElpBD";
var _2 = "wy6XM";
var _3 = "j_Ex2";
var _4 = "ofOgF";
var _5 = "Jykv1";
var _6 = "ecAzR";
var _7 = "HpkzU";
var _8 = "_EhL7";
var _9 = "Vevdt";
var _a = "Fngi_";
var _b = "hcKGx";
var _c = "PcLnc";
var _d = "B5Hxq";
var _e = "a3B86";
var _f = "Vax0y";
var _10 = "I_r8z";
var _11 = "rxg0D";
export { _1 as "heading", _2 as "heading-1", _3 as "heading-2", _4 as "heading-3", _5 as "heading-4", _6 as "heading-5", _7 as "monospaced", _8 as "overflow-ellipsis", _9 as "text", _a as "text-body", _b as "text-body-compact", _c as "text-display", _d as "text-small", _e as "ui-text", _f as "ui-text-body", _10 as "ui-text-display", _11 as "ui-text-small" }
